const applyConfig = (config) => {
  const linkAreaPersonale =
    (__CLIENT__ && window.env.RAZZLE_LINK_AREA_PERSONALE) ||
    process.env.RAZZLE_LINK_AREA_PERSONALE ||
    '';
  config.settings = {
    ...config.settings,
    // italiaThemeViewsConfig: {
    //   ...config.settings.italiaThemeViewsConfig,
    //   imagePosition: 'afterHeader', // possible values: afterHeader, documentBody
    // },
    siteProperties: {
      /*
        Per tutte le props di siteProperties, può essere definito un oggetto per i siti multilingua, strutturato in questo modo:
        {'default': _valore_della_prop, 'it': _valore_della_prop,...}
        Se l'oggetto non è strutturato in questo modo, viene usato l'oggetto stesso, altrimenti viene preso il valore della corrispondente alla prop della lingua corrente o alla prop 'default' se esiste.
      */
      ...config.settings.siteProperties,
      siteTitle: undefined,
      siteSubtitle: undefined,
      subsiteParentSiteTitle: undefined,
      parentSiteTitle: 'Regione Emilia-Romagna',
      parentSiteURL: 'https://regione.emilia-romagna.it',
      arLoginUrl: linkAreaPersonale,
      userLoggedMenu: [
        {
          href: {
            it: linkAreaPersonale,
          },
          title: { it: 'Area personale' },
          className: 'area-personale-link',
        },
        ...(config.settings.siteProperties.userLoggedMenu ?? []),
      ],
    },
    'volto-gdpr-privacy': {
      ...config.settings['volto-gdpr-privacy'],
      defaultPanelConfig: null,
    },
  };

  // config.views = {
  //   ...config.views,
  // };
  // config.widgets = {
  //   ...config.widgets,
  // };

  config.blocks.blocksConfig.listing = {
    ...config.blocks.blocksConfig.listing,
    variations: [
      ...config.blocks.blocksConfig.listing.variations,
      // {
      //   id: 'cardWithSideImageTemplate',
      //   isDefault: false,
      //   title: 'Card con immagine affiancata',
      //   template: CardWithSideImageTemplate,
      //   skeleton: CardWithSideImageTemplateSkeleton,
      //   schemaEnhancer: ({ schema, formData, intl }) => {
      //     let pos = addDefaultOptions(schema, formData, intl);
      //     addCardWithSideImageTemplateOptions(schema, formData, intl, pos);
      //     return schema;
      //   },
      // },
    ],
    listing_bg_colors: [
      { name: 'primary', label: 'primary' },
      { name: 'tertiary', label: 'tertiary' },
      { name: 'trasparent', label: 'trasparent' },
    ], //{name:'blue', label:'Blu'},{name:'light-blue', label:'Light blue'},{name:'sidebar-background', label:'Grey'}
    listing_items_colors: [], //{name:'blue', label:'Blu'},{name:'light-blue', label:'Light blue'},{name:'sidebar-background', label:'Grey'}
  };

  //config.settings["volto-gdpr-privacy"].defaultPanelConfig.text.it.description =
  //"Questo sito utilizza i cookie tecnici di navigazione e di sessione per garantire un miglior servizio di navigazione del sito, e cookies analitici per raccogliere informazioni sull'uso del sito da parte degli utenti.  Utilizza anche cookies di profilazione dell'utente per fini statistici. Per i cookie di profilazione puoi decidere se abilitarli o meno cliccando sul pulsante 'Impostazioni'. Per saperne di più, su come disabilitare i cookies oppure abilitarne solo alcuni, consulta la nostra <a href='/privacy'>Cookie Policy</a>.";

  return config;
};

export default applyConfig;
